// Module
var code = `<div class="HOA-Menu-wrapper">
    <ul class="HOA-menu-list">
        <!-- MAIN NAV ITEMS - SHOW IF PHONE SIZE -->
        <div class="HOA-nav-menu-list">
            <ng-container *ngFor="let item of mainNavItems">
                <li class="hide-if-platform-size-tablet-or-desktop HOA-nav-menu-items"
                    [attr.tid]="item.tid + '-menu'">
                    <button (click)="navToTab(item.section)" class="HOA-nav-menu-items__button">
                        <span [class.is-active]="item.section === currentSection" [attr.tid]="item.tid + '-menu-span'">
                            {{item.name}}
                        </span>
                    </button>
                </li>
            </ng-container>
        </div>
        <!-- MORE NAV ITEMS -->
        <div class="HOA-more-menu-list">
            <li *ngFor="let item of moreLinks" class="HOA-more-menu-item">
                <a *ngIf="item.route !== undefined" (click)="closeSubMenu(item.route)" href="javascript:void(0);">
                    <span [attr.tid]="item.tid">{{item.text}}</span>
                </a>
                <a *ngIf="item.onclick && item.text !== 'Logout'" (click)="onclick(item.onclick)" href="javascript:void(0);">
                    <span [attr.tid]="item.tid">{{item.text}}</span>
                </a>
                <button *ngIf="item.onclick && item.text == 'Logout'" (click)="onclick(item.onclick)"
                        class="HOA-more-menu-item__logutButton">
                    <span [attr.tid]="item.tid">{{item.text}}</span>
                </button>
            </li>
        </div>
    </ul>

    <div class="hide-if-platform-web HOA-splash-copy-details HOA-more-version-number">
        <div class="u-whitespace--pre" tid="poweredBy">Powered by First Citizens Bank</div>
        <div class="version-number u-whitespace--pre" tid="appVersion">App Version: {{appVersion}}</div>
    </div>
</div>`;
// Exports
module.exports = code;